<form
	[formGroup]="formGroup"
	[ngClass]="{'mt-5': addSpaceToPrevious}"
>
	<div
		class="row mb-3 formElementWrapper"
		[ngClass]="baseCssClass"
		(mouseover)="setHovered( true )"
		(mouseout)="setHovered( false )"
	>

		<!-- Label -->
		<ng-container *ngIf="!config.hideLabel">
			<app-label
				formEntityId="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
				labelText="{{ labelText ? labelText : getI18nString(false, translationPath + '.label') }}"
				[labelClassObject]="{
					'hovered': isHovered,
					'focused': hasFocus,
					'error': control?.errors && !hideErrors
				}"
				[labelHostClassString]="labelHostClassString"
				[labelInfoInline]="labelInfoInline"
				[required]="isRequired"
				[requiredByElster]="config.elsterRequiredField"
				[showElsterIndicator]="config.elsterShowIndicator"
			></app-label>
		</ng-container>

		<!-- Input Block -->
		<div class="inputBlockWrapper col-12 col-md-8">

			<div class="col-{{colSpan}} px-0">
				<!-- Input Wrapper -->
				<div
					class="inputWrapper mb-1"
					[ngClass]="{
						'controlDisabled': disableControl,
						'hovered': isHovered,
						'focused': hasFocus,
						'error': control?.errors && !hideErrors
					}"
				>

					<!-- Input Group -->
					<div class="d-flex px-2">

						<textarea
							class="form-control"
							formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
							id="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
							placeholder="{{ config.hidePlaceholder ? null : getI18nString(false,translationPath + '.placeholder') }}"
							tabindex="{{config.tabindex}}"
							type="text"
							[attr.data-e2e]="formEntityId + '-text'"
							[readOnly]="readOnly || disableControl"
							appFormControlTrim
							(focusin)="setFocus( true )"
							(focusout)="setFocus( false )"
						></textarea>

						<!-- Actions -->
						<div class="d-flex input-actions">
							<div *ngIf="showClearButton">
								<i class="input-group-text ft-x" (click)="clearControlValue()"></i>
							</div>

							<div *ngIf="showRevertButton">
								<i class="input-group-text icon-action-undo" (click)="revertControlValue()"></i>
							</div>
						</div>
					</div>
				</div>

				<div
					*ngIf="maxLength"
					class="
						form_control_maxLength--color text-end
						fs-md fw-regular
					"
					[ngClass]="{
						'form_control_maxLength-exceeded--color': currentTextLength > maxLength
					}"
				>
					<span>{{ currentTextLength }} / {{ maxLength }}</span>
				</div>

				<!-- Error -->
				<app-error
					[control]="control"
					[hideErrors]="hideErrors || hideErrorDescriptions"
					[errorMsg]="errorMsg"
				></app-error>
			</div>

			<!-- Input Information -->
			<app-info
				[baseClass]="'col-12 mb-3 mt-2 px-0'"
				[hideInfoIcon]="true"
				[infoText]="getI18nString( false, translationPath + '.info' )"
			></app-info>
		</div>
	</div>
</form>
